import { createContext, useContext, useState, useEffect } from "react";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem("jurisia_mode") || "citizen");

  useEffect(() => {
    localStorage.setItem("jurisia_mode", mode);
    const root = document.documentElement;
    if (mode === "pro") {
      root.classList.add("mode-pro");
      root.classList.remove("mode-citizen");
    } else {
      root.classList.add("mode-citizen");
      root.classList.remove("mode-pro");
    }
  }, [mode]);

  const toggle = () => setMode((m) => (m === "citizen" ? "pro" : "citizen"));

  return <ThemeCtx.Provider value={{ mode, setMode, toggle }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
